<script lang="ts">
import { defineComponent, inject, PropType, ref } from "vue";
import { TarifoptionInformation } from "@/components/tarifoptionen/model/TarifoptionInformation";
import IconSprite from "@/components/IconSprite.vue";
import { inputChangeHandler } from "@/businesslogic/utils/events";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "TarifoptionEineLinie",
  methods: { inputChangeHandler },
  components: { IconSprite },
  props: {
    tarifoptionInformation: {
      type: Object as PropType<TarifoptionInformation>,
      required: true,
    },
    tarifoptionentitel: {
      type: String,
      required: false,
    },
    modelValue: [Number, String],
  },
  emits: ["update:modelValue"],
  setup(props) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    const titelText = ref(
      piniaStore.state.isMakler && props.tarifoptionInformation?.titelMakler !== undefined
        ? props.tarifoptionInformation?.titelMakler
        : props.tarifoptionInformation?.titel,
    );

    const zeigeInfoItem = () => {
      const verberge = piniaStore.state.isMakler
        ? props.tarifoptionInformation?.zeigeInfoItemMakler == false
        : props.tarifoptionInformation?.zeigeInfoItem == false;

      return props.tarifoptionInformation?.infoItem && !verberge;
    };

    const sollSichtbarSein = () => {
      return !piniaStore.state.tarifOptionenZuVerbergen.includes(props.tarifoptionInformation?.typ);
    };

    return {
      props,
      piniaStore,
      titelText,
      istSichtbar,
      wechsleSichtbarkeit,
      zeigeInfoItem,
      sollSichtbarSein,
    };
  },
});
</script>

<template>
  <div v-if="sollSichtbarSein()" class="o-grid o-grid--align-middle">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 row-label">
      <h2 v-if="props.tarifoptionentitel !== undefined" class="u-form-heading unset-text-align">
        {{ props.tarifoptionentitel }}
      </h2>
      <span v-else class="row_label__fix">
        {{ titelText }}
        <span
          v-if="zeigeInfoItem()"
          class="gev19__contexthelp-open"
          title="Hilfe anzeigen"
          @click="wechsleSichtbarkeit(props.tarifoptionInformation?.infoItem?.name)"
        >
        </span>
      </span>
    </div>
    <div
      v-if="zeigeInfoItem()"
      v-show="istSichtbar(props.tarifoptionInformation?.infoItem?.name)"
      class="c-modal"
      data-modal=""
    >
      <section class="c-modal__content">
        <header class="c-modal__header">
          <h1 class="c-modal__title">
            {{ props.tarifoptionInformation?.infoItem?.titel }}
          </h1>
          <button
            type="button"
            class="c-button c-button--icon-only-white"
            data-modal-hide=""
            @click="wechsleSichtbarkeit(props.tarifoptionInformation?.infoItem?.name)"
          >
            <icon-sprite icon-name="icon-cross" />
            <span class="c-button__visually-hidden">close</span>
          </button>
        </header>
        <section class="c-modal__content-section">
          {{ props.tarifoptionInformation?.infoItem?.text }}
        </section>
      </section>
    </div>

    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y"
    >
      <div class="c-form-control">
        <select
          :name="props.tarifoptionInformation.selectname"
          :value="modelValue"
          @input="$emit('update:modelValue', inputChangeHandler($event))"
          class="chooseOptionsSelect c-form-control-select u-text-align-center u-mar-0"
          :data-cy="props.tarifoptionInformation.selectname"
          :aria-label="props.tarifoptionInformation.selectname"
        >
          <option
            v-for="(option, index) in props.tarifoptionInformation.selectoptionen"
            :key="index"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
